import   React                 ,
       { useState              ,
         useEffect             } from 'react';

import   classNames              from 'classnames';

import   styles                  from './ProductCategoryCreation.module.scss';

import   Field                   from '../../widget/inputs/Field';
import   Toggle                  from '../../widget/inputs/Toggle';
import   Trigger                 from '../../widget/actuators/Trigger';
import   Select                  from '../../widget/inputs/Select';
import   Window                  from '../../widget/windows/window';
import   WidgetFrame            from '../../widget/navigation/WidgetFrame';

import { useTypedSelector }      from '../../../store/useTypeSelector';
import { RootState }             from '../../../store/generalReducer';

import { createProductCategory } from '../../../backendServices/productManagment/api_productCategory';
import { DUPLICATE_NAME_CODE }  from '../../../dataTypes/backendServicesManagment/types';
import { ProductCategory }       from '../../../dataTypes/productManagment/types';

export interface ProductCategoryCreationProps {
  onCreate      : (createdCategory?: ProductCategory) => void;
  numCategories : number;
}

export const ProductCategoryCreation = ({ onCreate      ,
                                          numCategories }: ProductCategoryCreationProps) => {

  const { authentication } = useTypedSelector((state: RootState) => state.authenticationReducer);

  const [ name           , setName           ] = useState('');
  const [ rank           , setRank           ] = useState(1);
  const [ visible        , setVisible        ] = useState(false);
  
  const [ nameErrorMessage , setNameErrorMessage ] = useState("");
  const [ rankOptions    , setRankOptions    ] = useState<string[]>([]);
  const [ errorMessage   , setErrorMessage   ] = useState(<></>);
  const [ successMessage , setSuccessMessage ] = useState(<></>);
  const [ showWindow     , setShowWindow     ] = useState(false);
  const [ isSuccess      , setIsSuccess      ] = useState(false);
  const [ createdCategory , setCreatedCategory ] = useState<ProductCategory | undefined>(undefined);

  useEffect(() => {
    const options = Array.from({ length: numCategories + 1 }, (_, i) => (i+1).toString());
    setRankOptions(options);
  }, [numCategories]);

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
	
	if ( event.target.value === '' )
	      {
	       setNameErrorMessage ("Le nom ne peut pas être vide") 
	      }
	 else {
	       setNameErrorMessage ("") 
	      }
  };

  const handleRankChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setRank(parseInt(event.target.value, 10));
  };

  const handleVisibilityChange = (newState: boolean) => {
    setVisible(newState);
  };

  const addCategory = async () => {
	  
	if ( name === '' )
	      {
           setNameErrorMessage ("Le nom ne peut pas être vide") 
		  }
     else {		
           setNameErrorMessage ("") 

		   const result = await createProductCategory(name, rank, visible, authentication.admin?.id);

           if (result.code === 1)
                 {
                  setSuccessMessage(<>La catégorie a été créée avec succès !</>);
                  setErrorMessage(<></>);
                  setIsSuccess(true);
                  setCreatedCategory(result.payload);
                  setShowWindow(true);
                  setName('');
                  setRank(0);
                  setVisible(false);
                 }
            else {
                  setSuccessMessage(<></>);
                  // Un nom déjà pris par une catégorie du même créateur se dit tel quel : c'est
                  // le seul refus que l'utilisateur peut corriger lui-même, et le message
                  // général le laissait croire à une panne.
                  setErrorMessage(result.code === DUPLICATE_NAME_CODE
                                  ? <>Cette catégorie existe déjà</>
                                  : <>Une erreur est survenue lors de la création de la catégorie.</>);
                  setIsSuccess(false);
                  setCreatedCategory(undefined);
                  setShowWindow(true);
                 }
	      }		
  };

  const handleAddButton = () => {
    addCategory();
  };

  const handleCloseWindow = () => {
    setShowWindow(false);
    if (isSuccess) {
      onCreate(createdCategory);
    }
  };

  return (
    <div className={classNames(styles.root)}>

        <div className={classNames(styles.container)}>
		
          <div className={classNames(styles.container2)}>
		    <WidgetFrame name               = "Nom :"
                         error              = {nameErrorMessage}
                         labelTextPosition  = "right"
                         labelBlockPosition = "left" 
                         classNameGrid      = {classNames(styles.grid_frame)} >

              <Field type        = "text"
                     placeholder = ""
                     value       = {name}
                     onChange    = {handleNameChange}
                     width       = "450px"/>
            </WidgetFrame>
          </div>
		  
          <div className={classNames(styles.container2)}>
		    <WidgetFrame name               = "Rang :"
                         labelTextPosition  = "right"
                         labelBlockPosition = "left" 
                         classNameGrid      = {classNames(styles.grid_frame)} >
              <Select choices  = {rankOptions}
                    value    = {rank.toString()}
                    onChange = {handleRankChange} />
            </WidgetFrame>
          </div>
		  
          <div className={classNames(styles.container2)}>
		    <WidgetFrame name               = "Visible :"
                         labelTextPosition  = "right"
                         labelBlockPosition = "left" 
                         classNameGrid      = {classNames(styles.grid_frame)} >
              <Toggle checked  = {visible}
                      form     = "switch"
                      onChange = {handleVisibilityChange} />
            </WidgetFrame>
          </div>
		  
          <Trigger name    = "Ajouter"
                   onClick = {handleAddButton}
                   variant = "tailwind2" />
        </div>

      {
        showWindow &&
        (
          <Window message                 = {isSuccess ? successMessage : errorMessage}
                  messageImportance       = {isSuccess ? 'normal' : 'important'}
                  onClickOnValidateButton = {handleCloseWindow} />
        )
      }
	  
    </div>
  );
};

export default ProductCategoryCreation;
